import React, { Component } from 'react';
import { Link, browserHistory } from 'react-router';

import './App.css';

import Filter from './components/Filter';
import Icon from './components/Icon';
import rebase from './rebase';

class App extends Component {
  constructor() {
    super();

    this.state = {
      isEditing: false,
      hideSelected: false,
      filter: ''
    };
  }

  handleEdit = () => {
    if (!this.state.filter) {
      this.setState(state => ({ isEditing: !state.isEditing }));
    }
  }

  handleHideSelected = () => {
    this.setState(state => ({ hideSelected: !state.hideSelected }));
  }

  handleFilterChange = filter => {
    const newState = { filter };

    if (filter && this.state.isEditing) {
      newState.isEditing = false;
    }

    this.setState(newState);
  }

  handleLogout = () => {
    rebase.unauth();
    browserHistory.push('/login');
  }

  render() {
    const isListsRoute = this.props.location.pathname === '/';
    const isLoginRoute = this.props.location.pathname === '/login';

    return (
      <div className="App">

        <div className="App-header">
          <div className="App-header-left">
            {(isListsRoute || isLoginRoute) && <h2 onClick={this.handleLogout}>ReShop</h2>}
            {!(isListsRoute || isLoginRoute) && <Link to="/"><Icon id="arrow-left" /></Link>}
          </div>
          {!isLoginRoute && <div className="App-header-right">
            {!isListsRoute && <Filter value={this.state.filter} onChange={this.handleFilterChange} />}
            {!isListsRoute && <Icon id="filter" isSelected={this.state.hideSelected} onClick={this.handleHideSelected} />}
            <Icon id="mode_edit" isSelected={this.state.isEditing} onClick={this.handleEdit} />
          </div>}
        </div>

        <div className="App-content">
          {React.cloneElement(this.props.children, { isEditing: this.state.isEditing, hideSelected: this.state.hideSelected, filter: this.state.filter })}
        </div>
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/